module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//2.jpg?919e42d82d3c9547f96b4d60b72bb438";